export const UPDATE_FILTER_CONTRACTS_TOKEN = "UPDATE_FILTER_CONTRACTS_TOKEN";
export const UPDATE_FILTER_CONTRACTS_PAGENUMBER = "UPDATE_FILTER_CONTRACTS_PAGENUMBER";
export const UPDATE_FILTER_CONTRACTS_SORT = "UPDATE_FILTER_CONTRACTS_SORT";
export const UPDATE_FILTER_CONTRACTS_OBJECT = "UPDATE_FILTER_CONTRACTS_OBJECT";
export const CLEAR_FILTER_CONTRACTS = "CLEAR_FILTER_CONTRACTS";
export const UPDATE_CONTRACT_DATA = "UPDATE_CONTRACT_DATA";
export const UPDATE_CONTRACTS_DATA = "UPDATE_CONTRACTS_DATA";
export const UPDATE_HOME_CONTRACTS_DATA = "UPDATE_HOME_CONTRACTS_DATA";

export const UPDATE_EVENT_FILE = "UPDATE_EVENT_FILE";
export const UPDATE_HOLDINGS_FILE = "UPDATE_HOLDINGS_FILE";
export const UPDATE_RESEARCH_FILE = "UPDATE_RESEARCH_FILE";
export const UPDATE_PORTFOLIO = "UPDATE_PORTFOLIO";
